import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProfileHeading({ title }: { title: string }) {
  return (
    <h2
      className={cn(
        'w-full text-center text-3xl font-medium text-black sm:text-4xl lg:text-5xl xl:text-6xl',
        'font-heading tracking-tight',
      )}
    >
      {title}
    </h2>
  );
}
